import React from "react";
import { MessageDescriptor } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import {
	closeNotification,
	createNotification
} from "src/features/notifications/actions";
import { Notification } from "src/features/notifications/types";
import { genericMessages } from "src/messages/generic";
import { AppDispatch } from "src/store";

export function useNotificationList(): Notification[] {
	return useSelector(
		({ notifications }: { notifications: Notification[] }) => notifications
	);
}

export function useCreateMessage(): (message: MessageDescriptor) => void {
	return useCreateNotification("message");
}

export function useCreateWarning(): (message: MessageDescriptor) => void {
	return useCreateNotification("warning");
}

export function useCreateError(): (message: MessageDescriptor) => void {
	return useCreateNotification("error");
}

export function useCreateGenericError(): () => void {
	const createError = useCreateError();
	return React.useCallback(() => {
		createError(genericMessages.somethingWentWrong);
	}, [createError]);
}

function useCreateNotification(
	variant: "message" | "warning" | "error"
): (message: MessageDescriptor) => void {
	const dispatch: AppDispatch = useDispatch();
	return React.useCallback(
		(message: MessageDescriptor) => {
			dispatch(createNotification({ variant, content: message }));
		},
		[dispatch, variant]
	);
}

export function useCloseNotification(): (id: number) => void {
	const dispatch: AppDispatch = useDispatch();
	return React.useCallback(
		id => {
			dispatch(closeNotification(id));
		},
		[dispatch]
	);
}
